var heading_default = {
  "fontElementMap": "_0k3o7",
  "elementSpacing": "dx0UJ",
  "headerOne": "haopS dx0UJ",
  "headerTwo": "A8xcM dx0UJ",
  "headerThree": "_0U3jY dx0UJ",
  "headerFour": "XbYX9 dx0UJ",
  "headerFive": "xcif6 dx0UJ",
  "headerSix": "_7ZnET dx0UJ",
  "child": "IeDw5"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
